var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOsmandMapsPlusV2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 16.5C3 8.21573 9.71573 1.5 18 1.5C26.2843 1.5 33 8.21573 33 16.5C33 22.7153 29.2199 28.0476 23.8333 30.3235C21.5417 31.2917 19.875 32.125 19.4583 33.7917C19.25 34.625 18.7292 35.25 18 35.25C17.2708 35.25 16.75 34.625 16.5417 33.7917C16.125 32.125 14.4583 31.2917 12.1667 30.3235C6.7801 28.0476 3 22.7153 3 16.5ZM18 24C22.1421 24 25.5 20.6421 25.5 16.5C25.5 12.3579 22.1421 9 18 9C13.8579 9 10.5 12.3579 10.5 16.5C10.5 20.6421 13.8579 24 18 24Z",
    fill: "url(#paint0_linear_240_5490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16.5C25.5 20.6421 22.1421 24 18 24C13.8579 24 10.5 20.6421 10.5 16.5C10.5 12.3579 13.8579 9 18 9C22.1421 9 25.5 12.3579 25.5 16.5Z",
    fill: "url(#paint1_linear_240_5490)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 1.5C29.3284 1.5 30 2.17157 30 3V6H33C33.8284 6 34.5 6.67157 34.5 7.5C34.5 8.27651 33.91 8.91568 33.1538 8.99268L33 9H30V12C30 12.8284 29.3284 13.5 28.5 13.5C27.6716 13.5 27 12.8284 27 12V9H24L23.8462 8.99268C23.09 8.91568 22.5 8.27651 22.5 7.5C22.5 6.72349 23.09 6.08432 23.8462 6.00732L24 6H27V3C27 2.17157 27.6716 1.5 28.5 1.5Z",
    fill: "url(#paint2_linear_240_5490)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_5490",
    x1: 18,
    y1: 1.5,
    x2: 18,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_5490",
    x1: 18,
    y1: 9,
    x2: 18,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B35F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC6D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_240_5490",
    x1: 28.5,
    y1: 1.5,
    x2: 28.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732EEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOsmandMapsPlusV2);
export default __webpack_public_path__ + "static/media/ic_action_osmand_maps_plus_v2.2ae146605c4f4cb9eba85e930b80033c.svg";
export { ForwardRef as ReactComponent };